import { EnhancedError } from "./EnhancedError.js";
/** Thrown if e.g. a value is required but wasn't provided. */
export class RequiredError extends EnhancedError {
    code = "not-found";
    constructor(message = "Value is required", context) {
        super(message, context);
    }
}
RequiredError.prototype.name = "RequiredError";
